module.exports = __webpack_public_path__ + "static/events_pic-bbaa8a1a46f250afe9d4ff729ed68f41.png";